import React from "react";
import Header from "../components/header";
import Footer from '../components/footer';
import FloatingChatButton from '../components/FloatingChatButton';

const TermsAndService = () => (
  <div className="bg-white min-h-screen flex flex-col">
    <Header />
    <main className="flex-grow container mx-auto px-4 py-12">
      <h1 className="text-4xl font-bold mb-8 text-center">
        Terms and Services
      </h1>
      <div className="max-w-3xl mx-auto text-gray-700 text-lg space-y-6">
        <h2 className="text-2xl font-semibold mb-4">
          Platform, Sphere and Activity
        </h2>
        <p>
          1.1 The Medical Linkers Internet platform,{" "}
          <a
            href="https://www.MedicalLinkers.com"
            className="text-blue-600 underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            www.MedicalLinkers.com
          </a>{" "}
          (hereinafter Medical Linkers), is a service delivery portal that
          provides users with general information about clinical disease
          patterns, diagnoses, treatment options, clinics and doctors
          (hereinafter Providers).
        </p>
        <p>
          1.2 These Terms of Use (hereinafter the Terms and Conditions) contain
          the basic rules for the use of the Medical Linkers international
          Internet platform,{" "}
          <a
            href="https://www.MedicalLinkers.com"
            className="text-blue-600 underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            www.MedicalLinkers.com
          </a>
          , and apply to all contracts, transactions and activities between
          Medical Linkers and platform users (hereinafter: Users).
        </p>
        <p>
          1.3 Using the Medical Linkers service confirms that the User is
          familiar with these Terms and accepts them.
        </p>
        <p>
          1.4 The use of basic platform services is free of charge. However,
          Medical Linkers reserves the right to offer additional paid services
          to the User at the request of the User (translation services,
          organization of exclusive services, any other services not related to
          the core business of the company, medical insurance, etc.)
        </p>

        <h2 className="text-2xl font-semibold mb-4">Services</h2>
        <p>
          2.1{" "}
          <a
            href="https://www.MedicalLinkers.com"
            className="text-blue-600 underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            www.MedicalLinkers.com
          </a>{" "}
          is an international Internet service platform administered by the
          Medical Linkers company of the same name. The platform provides users
          with the opportunity to get information about diseases, diagnoses,
          treatment options, clinics and doctors. Medical Linkers supports the
          user in finding a suitable clinic by providing detailed information
          about the different clinics and their main areas of treatment. In
          addition, Medical Linkers provides useful information on how to
          prepare for a trip and stay in the country chosen for the treatment
          (for example, the necessary documents, conditions of entry,
          recommendations for travel, etc.). When the User registers the e-mail
          address, Medical Linkers will make an informational dispatch of
          medical material.
        </p>
        <p>
          2.2 Using the Medical Linkers service confirms that the User is
          familiar with these Terms and accepts them.
        </p>
        <p>
          2.3 When the User makes a decision about the trip to the chosen
          clinic, Medical Linkers accompanies the user from the moment of
          commencement of the trip to the moment of returning home after the end
          of treatment / diagnosis, helps to resolve disputes with the clinic,
          if any arise and provides further information concerning his stay in
          the clinic, sends To him reminders of the admission of doctors, etc.
          All services offered by Medical Linkers are described in detail on the
          website of the Internet platform.
        </p>
        <p>
          2.4 Medical Linkers services are limited to platform administration.
          Medical Linkers services and materials from clinics or users do not
          substitute for professional treatment by a physician or specialist in
          non-traditional methods of treatment. The choice and conduct of a
          specific method of treatment is carried out exclusively by a doctor or
          the above-named persons. Medical Linkers does not provide medical
          services and does not give medical advice on treatment.
        </p>
        <p>
          2.5 Clinics material are provided by authorized person and doctors of
          specific medical institutions. Medical Linkers is not responsible for
          the content of the materials. Clinics or users located on the
          platform. The appropriate clinic or user is responsible for them.
          These materials are considered by Medical Linkers only in case of
          complaints and non-actuality of the information.
        </p>
        <p>
          2.6 In establishing contact between the user and the clinic, the
          contract for the provision of medical services is exclusively between
          the clinic and the user. The same applies to the conclusion of
          appropriate agreements with Medical Linkers partners in the provision
          of paid services for elite services. Medical Linkers is not
          responsible for the content of such contracts and for their execution
        </p>

        <h2 className="text-2xl font-semibold mb-4">Registration, Access</h2>
        <p>
          3.1 Obtaining a medical program, sending a request for treatment,
          contacting the clinic and obtaining a second medical opinion means the
          registration process on the site. The registration process is allowed
          only for individuals who have reached the age of 18.
        </p>
        <p>
          3.2 When registering on the site, the patient must indicate his
          personal data in the amount requested in the form of sending the
          request. The user is responsible for the completeness and correctness
          of the data indicated.
        </p>
        <p>
          3.3 Access data (desired user name, e-mail address and password) are
          intended solely for user use and can not be transferred to third
          parties. The user is required to keep the access data in secret in a
          safe place to prevent abuse by third parties.
        </p>
        <p>
          3.4 In case of abuse of access data by third parties or the occurrence
          of such suspicion, the user is obliged to immediately notify Medical
          Linkers. If abuse of access data occurs through the fault of the user,
          then he is responsible for it. User’s fault is considered to be
          present if it handles access data negligently or inadvertently. The
          user’s responsibility ends only at the time when he told the
          administrator about illegal use or lost it
        </p>

        <h2 className="text-2xl font-semibold mb-4">
          Payments, Deposits and Prepayments
        </h2>
        <p>
          4.1 All financial calculations for the provision of medical assistance
          or the provision of diagnostic services are conducted between the
          patient (user) and the clinic without the participation of Medical
          Linkers.
        </p>
        <p>
          4.2 In some cases, the clinic or partner has the right to demand
          payment of a deposit account before the patient arrives for treatment.
          Such cases include:
        </p>
        <ul className="list-disc ml-8">
          <li>
            Complex neurosurgical, oncological, spinal interventions in unstable
            patient condition (regardless of country and clinic).
          </li>
          <li>
            Children’s neurosurgical, neurooncological and oncological cases
            (regardless of country and clinic)
          </li>
          <li>Need for visa support</li>
          <li>
            The need for official confirmation of a visit to the clinic (a
            document on behalf of the clinic for officials and organizations)
          </li>
          <li>Treatment cases in countries with migration problems</li>
          <li>
            Cases of treatment for citizens of countries from regions with
            increased migration
          </li>
        </ul>
      </div>
    </main>
    <Footer />
      <FloatingChatButton />
  </div>
);

export default TermsAndService;
